import React from "react";

interface Props {
  className?: string;
}

const CircleCheck: React.FC<Props> = ({ className }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9 1.6875C4.96793 1.6875 1.6875 4.96793 1.6875 9C1.6875 13.0321 4.96793 16.3125 9 16.3125C13.0321 16.3125 16.3125 13.0321 16.3125 9C16.3125 4.96793 13.0321 1.6875 9 1.6875ZM12.8057 6.54926L8.08066 12.1743C8.02883 12.236 7.96434 12.2859 7.89155 12.3205C7.81877 12.3551 7.73939 12.3737 7.65879 12.375H7.6493C7.57045 12.375 7.4925 12.3584 7.42049 12.3263C7.34847 12.2942 7.28402 12.2473 7.23129 12.1887L5.20629 9.93867C5.15486 9.88413 5.11486 9.81985 5.08862 9.74962C5.06239 9.67939 5.05046 9.60463 5.05354 9.52973C5.05661 9.45482 5.07463 9.38129 5.10653 9.31345C5.13843 9.2456 5.18357 9.18482 5.23929 9.13468C5.29502 9.08453 5.3602 9.04602 5.43102 9.02143C5.50184 8.99683 5.57686 8.98664 5.65167 8.99146C5.72648 8.99627 5.79958 9.01599 5.86666 9.04945C5.93375 9.08292 5.99346 9.12945 6.0423 9.18633L7.63453 10.9554L11.9443 5.82574C12.041 5.71397 12.1778 5.64474 12.3251 5.633C12.4724 5.62126 12.6184 5.66796 12.7316 5.76301C12.8447 5.85806 12.9159 5.99382 12.9298 6.14095C12.9437 6.28807 12.8991 6.43474 12.8057 6.54926Z"
        fill="var(--iconSuccess)"
      />
    </svg>
  );
};

export default CircleCheck;
